import gql from 'graphql-tag';

export const BuildingNameQuery = gql`
	query BuildingNameQuery($objectId: [UUID]) {
		buildings(buildingsId: $objectId) {
			name
		}
	}
`;

export const BuildingFloorQuery = gql`
	query BuildingFloorQuery($buildingsId: [UUID]) {
		buildings(buildingsId: $buildingsId) {
			id
			floor {
				id
				name
				room {
					id
					name
				}
			}
		}
	}
`;

export const KPIQuery = gql`
	query KPIQuery {
		profile {
			kpi {
				comfort
				energy
				technicalStatus
			}
		}
	}
`;

export const DashboardBuildingEnergyConsumptionQuery = gql`
	query EnergyConsumptionWidget($buildingId: UUID!) {
		buildingEnergy(buildingId: $buildingId) {
			widgetConsumption {
				currentMeasurement
				percent
				period
				previousMeasurement
				units
				status
			}
		}
	}
`;

export const DashboardEnergyWidgetsQuery = gql`
	query DashboardEnergyWidgetsQuery($buildingId: UUID!) {
		buildingEnergy(buildingId: $buildingId) {
			widgetConsumption {
				currentMeasurement
				percent
				period
				previousMeasurement
				units
				status
			}
			benchmark {
				percent
				calculated
				benchmark
				status
			}
		}
	}
`;

export const DashboardBuildingEnergyAvailableYearsQuery = gql`
	query DashboardBuildingEnergyAvailableYearsQuery($buildingId: UUID!) {
		buildingEnergy(buildingId: $buildingId) {
			availableYears
		}
	}
`;

export const DashboardBuildingEnergyCharts = gql`
	query DashboardBuildingEnergyCharts(
		$buildingId: UUID!
		$period: [String]!
		$fromDate: Date!
		$toDate: Date
	) {
		buildingEnergy(buildingId: $buildingId) {
			chartEnergy(period: $period, fromDate: $fromDate, toDate: $toDate) {
				data
			}
		}
	}
`;

export const DashboardBuildingComfortQuery = gql`
	query DashboardBuildingComfortQuery(
		$buildingId: UUID!
		$search: String
		$floorId: [UUID]
		$comfortLevel: [String]
		$first: Int
		$last: Int
		$after: String
		$before: String
	) {
		buildingComfort(
			buildingId: $buildingId
			search: $search
			floorId: $floorId
			comfortLevel: $comfortLevel
		) {
			rooms(first: $first, after: $after, before: $before, last: $last) {
				pageInfo {
					endCursor
					hasNextPage
					hasPreviousPage
					startCursor
				}
				edges {
					cursor
					node {
						id
						name
						parameters
						organization {
							name
						}
						comfortLevel
						floor {
							name
						}
					}
				}
				totalCount
			}
		}
	}
`;

export const DashboardBuildingComfortChart = gql`
	query DashboardBuildingComfortChart(
		$buildingId: UUID!
		$roomId: UUID!
		$typeId: UUID!
		$period: String!
	) {
		buildingComfort(buildingId: $buildingId) {
			expandedChart(roomId: $roomId, typeId: $typeId, period: $period) {
				data
			}
		}
	}
`;

export const DashboardBuildingTechnicalStatus = gql`
	query DashboardBuildingTechnicalStatus(
		$buildingId: UUID!
		$predictive: [String]
		$search: String
		$status: [String]
	) {
		buildingTechnicalStatus(
			buildingId: $buildingId
			predictive: $predictive
			search: $search
			status: $status
		) {
			buildingId
			name
			systemRun
			sensorsCounter
			id
			info
			kpi {
				technicalStatus
			}
		}
	}
`;

export const TechStatusOverallAndMeasurementsQuery = gql`
	query TechStatusMeasurementsQuery($technicalStatusId: UUID!, $buildingId: UUID!) {
		buildingTechnicalStatus(buildingId: $buildingId) {
			details(technicalStatusId: $technicalStatusId) {
				overallState
				availableMeasurements
			}
		}
	}
`;

export const TechStatusSensorDataQuery = gql`
	query TechStatusSensorDataQuery(
		$technicalStatusId: UUID!
		$period: String!
		$typeId: UUID!
		$buildingId: UUID!
	) {
		buildingTechnicalStatus(buildingId: $buildingId) {
			details(technicalStatusId: $technicalStatusId) {
				sensorsData(period: $period, typeId: $typeId) {
					data
				}
			}
		}
	}
`;

export const BuildingInfoFragment = gql`
	fragment BuildingInfoFragment on BuildingType {
		id
		name
	}
`;

export const BuildingsListQuery = gql`
	query BuildingsListQuery($buildingsId: [UUID], $statuses: [String], $search: String) {
		buildings(buildingsId: $buildingsId, statuses: $statuses, search: $search) {
			...BuildingInfoFragment
			address {
				city
				id
				street
				lat
				lng
				number
			}
			kpi {
				comfort
				energy
				technicalStatus
			}
		}
	}
	${BuildingInfoFragment}
`;

export const SearchZonesUniversal = gql`
	query SearchZonesUniversal($buildingsId: [UUID], $statuses: [String], $search: String) {
		zones(buildingsId: $buildingsId, statuses: $statuses, search: $search) {
			id
			name
			assets {
				contentType
				name
				objectId
			}
			sensors {
				id
				name
			}
			kpi {
				comfort
				energy
				technicalStatus
			}
		}
	}
`;

export const SearchTenantsUniversal = gql`
	query SearchTenantsUniversal(
		$buildingsId: [UUID]
		$statuses: [String]
		$search: String
	) {
		tenants(buildingsId: $buildingsId, statuses: $statuses, search: $search) {
			tenant {
				name
				id
			}
			building {
				name
			}
			roomAmount
			floorAmount
			kpi {
				comfort
				energy
				technicalStatus
			}
		}
	}
`;
